export class Account {
    constructor(
      public guid:string = '',
      public name:string = '',
      public tipo_cliente:number = 1,
      public clasificacion:string = '',
      public segmento:string = '',
      public giro_cliente:number = 1,
      public ciudad:string = '',
      public calle:string  = '',
      public telefono:string  = ''
    )
    {}
  
    static fromJson(json:any) {
      if (!json) return;
          return new Account (
        json.ID,
        json.NAME,
        json.TIPO_CLIENTE_C,
        json.CLASIFICACION_C,
        json.SEGMENTO_C? json.SEGMENTO_C : '',
        json.GIRO_CLIENTE_C,
        json.BILLING_ADDRESS_CITY,
        json.BILLING_ADDRESS_STREET,
        json.PHONE_OFFICE
      );
    }
}


// WEBPACK FOOTER //
// /var/jenkins_home/workspace/srd-proinvel-pipeline/src/app/models/Account.ts